import type { Command, CommandStatus, CommandType } from '@/entities/command'
import type { IconName } from '@/shared/ui/Icon'
import type { StatusBadgeTone } from '@/shared/ui/StatusBadge'

export const STATUS_TONE: Record<CommandStatus, StatusBadgeTone> = {
  accepted: 'neutral',
  sent: 'accent',
  done: 'success',
  failed: 'danger',
  expired: 'warning',
}

export const TYPE_ICON: Record<CommandType, IconName> = {
  'reserve.place': 'box',
  'invoice.generate': 'doc',
  'payment.check': 'scale',
  'report.build': 'chart',
  'write-off': 'trash',
  'edo.upload': 'upload',
  'price.sync': 'retry',
  'documents.export': 'download',
}

/** Коды отказа, у которых есть свой текст; прочие получают общий. */
const KNOWN_ERRORS = ['ONE_C_UNAVAILABLE', 'OUT_OF_STOCK', 'EDO_TIMEOUT', 'CANCELED'] as const

export type KnownError = (typeof KNOWN_ERRORS)[number]

export function isKnownError(code: string | null): code is KnownError {
  return KNOWN_ERRORS.some((known) => known === code)
}

/** Идущая команда — та, что уже в 1С; очередь ждёт своего часа. */
export function isRunning(command: Command): boolean {
  return command.status === 'sent'
}

/** Ссылка на предмет команды: заказ открывается, у отчёта и каталога своей страницы нет. */
export function subjectPath(command: Command): string | null {
  return command.subject.kind === 'order' ? `/orders/${command.subject.id}` : null
}

/** Ссылка на итог: файл отчёта или архива из `result.url`. */
export function resultUrl(command: Command): string | null {
  const url = command.result?.url
  return typeof url === 'string' && url !== '' ? url : null
}
